
import Cpts020 from '@/components/lyx-components/cpts020/index.vue'

import util from '@/javascript/util'
import bus from '@/javascript/bus'
import Confirm from 'vux/src/components/confirm/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'


export default {
directives: {
TransferDom
},
components: {
Cpts020,
Confirm
},
data() {
return {
minHeight: 0,
list: [],
pageNo: 1,
pageSize: 10,
infiniteStatus: false,
infiniteAll: false,
confirmShow: false,
deleteIndex: -1,
userInfo: bus.userInfo.user ? bus.userInfo.user : {}
}
},
mounted() {
this.minHeight = document.documentElement.clientHeight
this.getList()
document.title = this.PAGE_TITLE + '我的行程'
/**
* 底部加载
*/
window.addEventListener('scroll', () => {
if (util.pullUpLoad()) {
this.infinite()
}
})
},
methods: {
infinite: function () {
if (this.infiniteAll) {
return
}
if (this.infiniteStatus) {
return
}
if (this.list.length == 0) {
return
}
this.infiniteStatus = true
this.pageNo += 1
this.getList()
},
getList() {
this.$http.get('api/wtcp-recommend/public/travelPlan/app/page?isAsc=false&page=' + this.pageNo + '&size=' + this.pageSize + '&status=1&userId=' + this.userInfo.id + '&deptCode=' + this.DEPT_CODE.DEPTCODE).then((response) => {
const that = this
if (response.data.data) {
let list = response.data.data.records ? response.data.data.records : []
list.forEach(item => {
let images = []
const imgData = []
images = images.concat(item.titleImages.split(','))
let arr = that.randomArr(images.length)
let data = that.RandomNumBoth(arr,0)
for (let i=0; i < 3 && i < data.length; i++) {
imgData.push(images[data[i]])
}
item.titleImages = imgData
})
this.list=this.list.concat(list)


}
if (response.data.data.records < this.pageSize) {
this.infiniteAll = true
}
this.infiniteStatus = false
})
},
deleteTrip(index) {
this.deleteIndex = index
this.confirmShow = true
},
onConfirm() {
const that = this
that.$http.delete('/api/wtcp-recommend/public/travelPlan/app/' + that.list[that.deleteIndex].id).then((response) => {
if (response.data.msg == 'success') {
that.list.splice(that.deleteIndex, 1)
}
})
},
randomArr(maxcount) {
let arr = [];
for (let i = 0; i < maxcount; i++) {
arr.push(i)
}
return arr;
},
RandomNumBoth(arr, maxNum) {
let numArr = [];

let arrLength = arr.length;
for (let i = 0; i < arrLength; i++) {


let number = Math.floor(Math.random() * arr.length); 

numArr.push(arr[number]);

arr.splice(number, 1);
if (arr.length <= maxNum) {
return numArr;
}
}
}
}
}
